import { render, staticRenderFns } from "./products2.vue?vue&type=template&id=882f041a&"
import script from "./products2.vue?vue&type=script&lang=js&"
export * from "./products2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports